export default __webpack_public_path__ + "static/media/DefaultLiveMachineIcon.9db69404.svg";